const Colors = {
    Elmt: {
        Black: 0x09222A,
        White: 0xFFFFFF,
        DarkBlue: 0x1E22AA,
        DeepBlue: 0x13156A,
        MiddleBlue: 0x6167BF,
        LightBlue: 0x4393C8,
        ThirdBlue: 0x9296D3,
        Beige: 0xF2F0E2,
    },
    Text: {
      Black: "#09222A",
        White: "#FFFFFF",
        DarkBlue: "#1E22AA",
        DeepBlue: "#13156A",
        MiddleBlue: "#6167BF",
        LightBlue: "#4393C8",
        ThirdBlue: "#9296D3",
        Beige: "#F2F0E2",
    }
}

export {
    Colors
}